import { Fragment, useState, useEffect } from "react"
import ActiveServicesMap from "./ActiveServicesMap";
import Breadcrumb from "../../layout/breadcrumb"
import { Container, Row, Col, Card, CardHeader, CardBody, Button, Table, Spinner } from "reactstrap"
import ApexCharts from "react-apexcharts"
import { MapPin, Users, Calendar } from "react-feather"
import authAxios from "../../services/Token"
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { format, subDays } from 'date-fns';
import { es } from 'date-fns/locale';
import './Dashboard.css';
import Swal from 'sweetalert2';

import {
  Modal, ModalHeader, ModalBody,
  Nav, NavItem, NavLink, TabContent, TabPane
} from "reactstrap";
import classnames from "classnames";

const tablas = {
  "Servicios Cancelados": [
    { servicio: "Limpieza", telefono: "3001234567", cliente: "Juan Pérez", correo: "juan@test.com", fecha: "2025-09-11" },
    { servicio: "Reparación", telefono: "3117654321", cliente: "Ana López", correo: "ana@test.com", fecha: "2025-09-11" },
  ],
  "Servicios Concluidos": [
    { servicio: "Instalación", telefono: "3209998888", cliente: "Carlos Ruiz", correo: "carlos@test.com", fecha: "2025-09-11" }
  ]
};

// Datos de prueba para conductores
const conductoresData = [
  {
    ranking: 1,
    nombre: "Carlos Pérez",
    concluidos: 45,
    cancelados: 2,
    aceptados: 48,
    asignados: 3,
  },
  {
    ranking: 2,
    nombre: "María González",
    concluidos: 38,
    cancelados: 1,
    aceptados: 42,
    asignados: 2,
  },
  {
    ranking: 3,
    nombre: "Juan Rodríguez",
    concluidos: 35,
    cancelados: 3,
    aceptados: 40,
    asignados: 1,
  },
  {
    ranking: 4,
    nombre: "Ana López",
    concluidos: 32,
    cancelados: 2,
    aceptados: 36,
    asignados: 4,
  },
  {
    ranking: 5,
    nombre: "Pedro Martínez",
    concluidos: 28,
    cancelados: 1,
    aceptados: 31,
    asignados: 2,
  },
]

// Datos de clientes
const clientesData = [
  { nombre: "Empresa ABC", servicios: 156 },
  { nombre: "Corporación XYZ", servicios: 89 },
  { nombre: "Grupo Delta", servicios: 67 },
  { nombre: "Industrias Beta", servicios: 45 },
]

const DashboardChart = ({ onMapDataLoaded, filters = {}, setFilters, startDate, endDate, setShowDatePicker, onBarClick }) => {
  const [showAll, setShowAll] = useState(false);
  // Estado para almacenar los datos del gráfico y estado de carga
  const [chartData, setChartData] = useState({
    loading: true,
    error: null,
    options: {
      chart: {
        type: 'bar',
        height: 500,
        stacked: true,
        toolbar: {
          show: true,
          tools: {
            download: true,
            selection: false,
            zoom: false,
            zoomin: false,
            zoomout: false,
            pan: false,
            reset: false
          }
        },
        fontFamily: 'inherit',
        animations: {
          enabled: true,
          easing: 'easeinout',
          speed: 800,
          animateGradually: {
            enabled: true,
            delay: 150
          },
          dynamicAnimation: {
            enabled: true,
            speed: 350
          }
        },
        events: {
          dataPointSelection: (event, chartContext, config) => {
            if (onBarClick && typeof onBarClick === 'function') {
              const serieIndex = config.seriesIndex;
              const dataPointIndex = config.dataPointIndex;
              onBarClick(serieIndex, dataPointIndex);
            }
          },
        },
      },
      // servicio concluido: 2ecc71
      // servicio pendiente: 3498db
      // servicio cancelado: e74c3c
      // servicio en curso: 9b59b6
      // servicio asignado: 1abc9c
      // servicio sin asignar: f1c40f
      // servicio aceptado: e67e22
      // servicio con salida parqueadero: e74c3c
      colors: ["#2ecc71", "#3498db", "#e74c3c", "#9b59b6", "#1abc9c", "#f1c40f", "#e67e22", "#e74c3c"],
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: '70%',
          borderRadius: 6,
          dataLabels: {
            position: 'top',
            total: {
              enabled: true,
              style: {
                fontSize: '13px',
                fontWeight: 700
              }
            }
          },
          endingShape: 'rounded'
        },
      },
      dataLabels: {
        enabled: true,
        formatter: function (val) {
          return val > 0 ? val : '';
        },
        style: {
          fontSize: '11px',
          colors: ["#333"]
        },
        offsetY: -20
      },
      stroke: {
        show: true,
        width: 1,
        colors: ['#fff']
      },
      xaxis: {
        categories: [],
        labels: {
          style: {
            colors: "#666",
            fontSize: "12px",
            fontWeight: 600
          },
        },
        axisBorder: {
          show: true,
          color: '#e0e0e0'
        },
        axisTicks: {
          show: true,
          color: '#e0e0e0'
        }
      },
      yaxis: {
        title: {
          text: 'Cantidad de Servicios',
          style: {
            color: '#666',
            fontSize: '12px',
            fontWeight: 600
          }
        },
        labels: {
          style: {
            colors: "#666",
            fontSize: "12px"
          },
          formatter: function (val) {
            return val % 1 === 0 ? val : '';
          }
        },
        axisBorder: {
          show: true,
          color: '#e0e0e0'
        }
      },
      fill: {
        opacity: 1,
        gradient: {
          shade: 'light',
          type: 'vertical',
          shadeIntensity: 0.25,
          gradientToColors: undefined,
          inverseColors: true,
          opacityFrom: 0.95,
          opacityTo: 0.8,
          stops: [0, 100]
        }
      },
      tooltip: {
        y: {
          formatter: function (val, { series, seriesIndex, dataPointIndex, w }) {
            const total = w.globals.stackedSeriesTotals[dataPointIndex];
            const percentage = Math.round((val / total) * 100);
            return `${val} servicios (${percentage}%)`;
          },
          title: {
            formatter: function (seriesName) {
              return seriesName;
            }
          }
        },
        shared: true,
        intersect: false,
        style: {
          fontSize: '14px'
        },
        marker: {
          show: true
        },
        fixed: {
          enabled: false,
          position: 'topRight',
          offsetX: 0,
          offsetY: 30
        }
      },
      legend: {
        position: 'top',
        horizontalAlign: 'left',
        offsetY: 4,
        markers: {
          width: 12,
          height: 12,
          radius: 2,
          offsetY: 1,
          strokeWidth: 1,
          strokeColor: '#fff',
          strokeOpacity: 0.9,
          shape: 'square'
        },
        itemMargin: {
          horizontal: 5,
          vertical: 4
        },
        onItemClick: {
          toggleDataSeries: true
        },
        onItemHover: {
          highlightDataSeries: true
        },
        formatter: function (seriesName, opts) {
          return [
            '<span class="apexcharts-legend-text" style="color: #373D3F; font-size: 12px; font-family: Helvetica, Arial, sans-serif;">',
            seriesName,
            '</span>'
          ].join('')
        }
      },
      responsive: [{
        breakpoint: 768,
        options: {
          chart: {
            height: 400
          },
          dataLabels: {
            enabled: false
          },
          legend: {
            position: 'bottom',
            horizontalAlign: 'center',
            offsetY: 0,
            onItemClick: {
              toggleDataSeries: false
            }
          }
        }
      }]
    },
    series: [
      {
        name: "Completados",
        data: [],
        type: 'column',
        color: "#2ecc71"
      },
      {
        name: "En Progreso",
        data: [],
        type: 'column',
        color: "#3498db"
      },
      {
        name: "Pendientes",
        data: [],
        type: 'column',
        color: "#f1c40f"
      },
      {
        name: "Cancelados",
        data: [],
        type: 'column',
        color: "#e74c3c"
      },
      {
        name: "Reagendados",
        data: [],
        type: 'column',
        color: "#9b59b6"
      },
      {
        name: "En Espera",
        data: [],
        type: 'column',
        color: "#1abc9c"
      }
    ]
  });


  const applyDateRange = () => {
    if (startDate && endDate) {
      // Create new date objects at noon to avoid timezone issues
      const startAtNoon = new Date(startDate);
      startAtNoon.setHours(12, 0, 0, 0);

      const endAtNoon = new Date(endDate);
      endAtNoon.setHours(12, 0, 0, 0);

      setFilters({
        fecha_inicio: format(startAtNoon, 'yyyy-MM-dd'),
        fecha_fin: format(endAtNoon, 'yyyy-MM-dd')
      });
      setShowDatePicker(false);
    }
  };

  // Function to handle legend item clicks
  const handleLegendClick = (chart, seriesIndex, config) => {
    // Get the chart instance
    const chartInstance = window.ApexCharts.getChartByID(chart.el.id);
    if (!chartInstance) return false;

    // Get the current series visibility
    const series = chart.w.globals.series;
    const isHidden = series[seriesIndex][0] === null;

    // If this is the only visible series, don't allow hiding it
    const visibleCount = series.filter(s => s[0] !== null).length;
    if (!isHidden && visibleCount <= 1) {
      return false;
    }

    // Toggle the series visibility
    chart.w.globals.collapsedSeriesIndices[seriesIndex] = isHidden ? -1 : 0;

    // Update the chart
    chartInstance.updateSeries([], true);

    // Prevent default behavior
    return false;
  };

  // Load dashboard data
  useEffect(() => {
    const fetchDashboardData = async () => {
      if (!filters.fecha_inicio || !filters.fecha_fin) return;

      try {
        const response = await authAxios.post('/dashboard-panel', {
          fecha_inicio: filters.fecha_inicio,
          fecha_fin: filters.fecha_fin
        });
        const data = response.data;

        // Check if the API call was successful and has the expected data structure
        if (!data.success || !data.data || !data.data.series || !data.data.categories) {
          console.error('Error al cargar los datos del dashboard');
          throw new Error('Formato de datos inválido del servidor');
        }

        const chartData = data.data; // Extract the actual chart data

        // Pass all active services to the map
        if (data.data.activos && Array.isArray(data.data.activos) && typeof onMapDataLoaded === 'function') {
          console.log('Passing active services to map:', data.data.activos);
          onMapDataLoaded(data.data.activos);
        } else {
          console.warn('No active services data found or invalid format:', data.data.activos);
        }

        // Map the series data to the format expected by ApexCharts
        const series = chartData.series.map((serie, index) => {
          // Keep all series visible by default
          return {
            name: serie.name,
            data: Array.isArray(serie.data) ? serie.data : []
          };
        });

        // Hide specific series by default (matching your example)
        const seriesToHideByDefault = [
          'Servicios Concluidos',
          'Servicios Pendientes',
          'Servicios Cancelados',
          'Servicios en Curso',
          'Servicios Asignados',
          'Servicios con Salida de Parqueadero'
        ];

        series.forEach((serie, index) => {
          if (seriesToHideByDefault.includes(serie.name)) {
            // Mark series as hidden in the chart data
            chartData.series[index].hidden = true;
          }
        });

        // Update chart data with the mapped series and categories
        setChartData(prev => ({
          ...prev,
          loading: false,
          options: {
            ...prev.options,
            xaxis: {
              ...prev.options.xaxis,
              categories: chartData.categories,
              labels: {
                ...prev.options.xaxis.labels,
                rotate: -90,
                rotateAlways: true,
                formatter: function (value) {
                  return value; // Keep the original date format from the API
                }
              }
            }
          },
          series: series
        }));
      } catch (error) {
        console.error('Error al cargar los datos del dashboard:', error);
        setChartData(prev => ({
          ...prev,
          loading: false,
          error: 'Error al cargar los datos del dashboard. Por favor, intente de nuevo más tarde.'
        }));
      }
    };

    fetchDashboardData();
  }, [filters]);

  if (chartData.loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: '300px' }}>
        <Spinner color="primary" />
        <span className="ms-2">Cargando datos del dashboard...</span>
      </div>
    );
  }

  if (chartData.error) {
    return (
      <div className="alert alert-danger" role="alert">
        {chartData.error}
      </div>
    );
  }

  return (
    <div style={{ width: "100%", overflowX: "auto" }}>
      <div style={{ minWidth: '100%', position: 'relative' }}>
        <div className="mb-3">
          <h5 className="text-center mb-3">Servicios en los Últimos 15 Días - Resumen</h5>
          <ApexCharts
            options={{
              ...chartData.options,
              chart: {
                ...chartData.options.chart,
                events: {
                  mounted: function (chartContext) {
                    const seriesToShowByDefault = [
                      "Servicios en Curso",    // 👈 las que quieres activas
                      "Servicios Pendientes"
                    ];

                    // Recorremos todas las series y ocultamos las que NO estén en la lista
                    chartData.series.forEach((serie) => {
                      if (!seriesToShowByDefault.includes(serie.name)) {
                        setTimeout(() => {
                          chartContext.hideSeries(serie.name);
                          // 👆 Esto hace que salgan desactivadas en el legend
                        }, 100);
                      }
                    });
                  },
                  click: (event, chartContext, config) => {
                    if (typeof onBarClick === "function" && config.seriesIndex !== undefined && config.dataPointIndex !== undefined) {
                      const serieIndex = config.seriesIndex;
                      const dataPointIndex = config.dataPointIndex;
                      const type = chartData.series[serieIndex]?.name;
                      const day = chartData.options.xaxis.categories[dataPointIndex];
                      // onBarClick(type, day);
                    }
                  },
                  dataPointSelection: (event, chartContext, config) => {
                    if (typeof onBarClick === "function") {
                      const serieIndex = config.seriesIndex;
                      const dataPointIndex = config.dataPointIndex;
                      const type = chartData.series[serieIndex]?.name;
                      const day = chartData.options.xaxis.categories[dataPointIndex];
                      onBarClick(type, day);
                    }
                  }
                }
              },
              states: {
                hover: {
                  filter: {
                    type: 'darken',
                    value: 0.1
                  }
                }
              },
              markers: {
                size: 0,
                hover: {
                  size: 6
                }
              },

              grid: {
                borderColor: '#f1f1f1',
                strokeDashArray: 4,
                yaxis: {
                  lines: {
                    show: true
                  }
                }
              }
            }}
            series={chartData.series}
            type="bar"
            height={400}
          />
        </div>

      </div>

      {/* Summary Table */}
      <div className="mt-4">
        <div className="table-responsive">
          <table className="table table-bordered table-hover">
            <thead className="table-light">
              <tr>
                <th>Fecha</th>
                <th style={{ color: "#2ecc71" }}>Concluidos</th>
                <th style={{ color: "#3498db" }}>Servicio Pendiente</th>
                <th style={{ color: "#e74c3c" }}>Cancelados</th>
                <th style={{ color: "#9b59b6" }}>En Servicio</th>
                <th style={{ color: "#1abc9c" }}>Asignados</th>
                <th style={{ color: "#f1c40f" }}>Salida de Parqueadero</th>
                <th className="fw-bold">Total</th>
              </tr>
            </thead>
            <tbody>
              {chartData.options.xaxis.categories.slice(0, showAll ? undefined : 5).map((date, dateIndex) => {
                const concluidos = chartData.series[0]?.data[dateIndex] || 0;
                const enServicio = chartData.series[1]?.data[dateIndex] || 0;
                const cancelados = chartData.series[2]?.data[dateIndex] || 0;
                const pendientes = chartData.series[3]?.data[dateIndex] || 0;
                const asignados = chartData.series[4]?.data[dateIndex] || 0;
                const salidaParqueadero = chartData.series[5]?.data[dateIndex] || 0;
                const total = concluidos + enServicio + cancelados + pendientes + asignados + salidaParqueadero;

                return (
                  <tr key={dateIndex}>
                    <td className="fw-medium">{date}</td>
                    <td style={{ color: "#2ecc71" }}>{concluidos}</td>
                    <td style={{ color: "#3498db" }}>{pendientes}</td>
                    <td style={{ color: "#e74c3c" }}>{cancelados}</td>
                    <td style={{ color: "#9b59b6" }}>{enServicio}</td>
                    <td style={{ color: "#1abc9c" }}>{asignados}</td>
                    <td style={{ color: "#f1c40f" }}>{salidaParqueadero}</td>
                    <td className="fw-bold">{total}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
          {chartData.options.xaxis.categories.length > 5 && (
            <div className="text-center mt-3">
              <button
                className="btn btn-sm btn-outline-primary"
                onClick={() => setShowAll(!showAll)}
              >
                {showAll ? 'Mostrar menos' : 'Ver todos'}
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

// Configuración del gráfico de servicios por mes
const MonthlyServicesChart = ({ filters = {}, setFilters, startDate, endDate, setShowDatePicker, handleMonthlyBarClick }) => {
  const [chartData, setChartData] = useState({
    loading: true,
    error: null,
    options: {
      chart: {
        type: "bar",
        height: 300,
        stacked: true,
        toolbar: { show: false },
        events: {
          dataPointSelection: handleMonthlyBarClick
        }
      },
      colors: ["#2ecc71", "#3498db", "#e74c3c", "#9b59b6", "#1abc9c", "#f1c40f", "#e67e22", "#e74c3c"],
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: '70%',
          borderRadius: 6,
          dataLabels: {
            position: 'top',
            total: {
              enabled: true,
              style: {
                fontSize: "13px",
                fontWeight: 700,
                colors: ["#000"]
              }
            }
          }

        },
      },
      dataLabels: {
        enabled: true,
        formatter: (val) => (val > 0 ? val : ""),
        style: {
          fontSize: "11px",
          colors: ["#333"]
        }
      },
      xaxis: {
        categories: [],
        labels: {
          style: {
            colors: "#666",
            fontSize: "12px",
          },
        },
      },
      yaxis: {
        labels: {
          style: {
            colors: "#666",
            fontSize: "12px",
          },
        },
      },
      fill: { opacity: 1 },
      legend: {
        position: "top",
        horizontalAlign: "left",
      },
      tooltip: {
        y: {
          formatter: (val) => val + " servicios",
        },
      },
    },
    series: []
  });

  const [valorClientesOptions, setValorClientesOptions] = useState({
    chart: {
      type: 'bar',
      stacked: true,
      toolbar: {
        show: false
      },
    },
    plotOptions: {
      bar: {
        horizontal: true,
        barHeight: '60%',
      },
    },
    dataLabels: {
      enabled: false,
    },
    xaxis: {
      categories: [],
      labels: {
        formatter: function (val) {
          return '$' + val.toLocaleString('es-CO');
        }
      },
      title: {
        text: 'Valor Total (COP)'
      }
    },
    yaxis: {
      labels: {
        formatter: function (val) {
          return val.length > 15 ? val.substring(0, 15) + '...' : val;
        }
      }
    },
    fill: {
      opacity: 1,
      colors: ['#5cb85c', '#5bc0de', '#f0ad4e', '#d9534f']
    },
    legend: {
      position: 'top',
      horizontalAlign: 'left',
    },
    tooltip: {
      y: {
        formatter: function (val) {
          return '$' + val.toLocaleString('es-CO');
        },
      },
    },
  });
  const [valorClientesSeries, setValorClientesSeries] = useState([]);
  const [monthlyTable, setMonthlyTable] = useState([]);
  const [showAllMonths, setShowAllMonths] = useState(false);


  useEffect(() => {
    const fetchMonthlyData = async () => {
      if (!filters.fecha_inicio || !filters.fecha_fin) return;

      try {
        const response = await authAxios.post('/dashboard-panel', {
          fecha_inicio: filters.fecha_inicio,
          fecha_fin: filters.fecha_fin
        });
        const { data } = response.data;

        if (!data) {
          throw new Error('Datos no disponibles');
        }

        // Process client values data
        if (data.valorServicio && data.valorServicio.length > 0) {
          // Group by client
          const clientValues = data.valorServicio.reduce((acc, item) => {
            const key = `${item.nombres} ${item.apellidos}`;
            if (!acc[key]) {
              acc[key] = {
                name: key,
                data: [0, 0, 0, 0], // [CONCLUIDO, EN SERVICIO, CANCELADO, OTROS]
                total: 0
              };
            }

            const index = item.estado === 'CONCLUIDO' ? 0 :
              item.estado === 'EN SERVICIO' ? 1 :
                item.estado === 'CANCELADO' ? 2 : 3;

            acc[key].data[index] = item.total;
            acc[key].total += item.total;

            return acc;
          }, {});

          // Convert to array and sort by total value
          const sortedClients = Object.values(clientValues)
            .sort((a, b) => b.total - a.total)
            .slice(0, 10); // Show top 10 clients

          // Update chart data
          setValorClientesOptions(prev => ({
            ...prev,
            xaxis: {
              ...prev.xaxis,
              categories: sortedClients.map(client => client.name)
            }
          }));

          setValorClientesSeries([
            {
              name: 'Concluidos',
              data: sortedClients.map(client => client.data[0])
            },
            {
              name: 'En Servicio',
              data: sortedClients.map(client => client.data[1])
            },
            {
              name: 'Cancelados',
              data: sortedClients.map(client => client.data[2])
            },
            {
              name: 'Otros',
              data: sortedClients.map(client => client.data[3])
            }
          ]);
        }

        const { series, categories } = data.mensual;

        const updatedSeries = (series || []).map((s) => {
          const total = s.data.reduce((a, b) => a + b, 0);
          return {
            ...s,
            originalName: s.name,
            name: `${s.name} (${total})`
          };
        });

        const buildMonthlyTable = (categories, series) => {
          return categories.map((month, idx) => {
            const row = { mes: month, total: 0 };
            series.forEach((s) => {
              const key = s.originalName || s.name;
              row[key] = s.data[idx] || 0;
              row.total += s.data[idx] || 0;
            });
            return row;
          });
        };


        const tableData = buildMonthlyTable(categories, series);

        setMonthlyTable(tableData);
        setChartData(prev => ({
          ...prev,
          loading: false,
          options: {
            ...prev.options,
            xaxis: {
              ...prev.options.xaxis,
              categories: categories || []
            }
          },
          series: updatedSeries || []
        }));
      } catch (error) {
        console.error('Error al cargar datos mensuales:', error);
        setChartData(prev => ({
          ...prev,
          loading: false,
          error: 'Error al cargar los datos mensuales'
        }));
      }
    };

    fetchMonthlyData();
  }, [filters]);

  if (chartData.loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: '300px' }}>
        <Spinner color="primary" />
        <span className="ms-2">Cargando datos mensuales...</span>
      </div>
    );
  }

  if (chartData.error) {
    return (
      <div className="alert alert-danger" role="alert">
        {chartData.error}
      </div>
    );
  }


  const rowsToShow = showAllMonths ? monthlyTable : monthlyTable.slice(0, 6);

  return (
    <>
      <ApexCharts
        options={chartData.options}
        series={chartData.series}
        type="bar"
        height={300}
      />
      {rowsToShow.length > 0 && (
        <div className="table-responsive mt-4">
          <table className="table table-bordered table-hover">
            <thead className="table-light">
              <tr>
                <th>Mes</th>
                
                {chartData.series.map((s, i) => {
                  // servicio concluido: 2ecc71
                    // servicio pendiente: 3498db
                    // servicio cancelado: e74c3c
                    // servicio en curso: 9b59b6
                    // servicio asignado: 1abc9c
                    // servicio sin asignar: f1c40f
                    // servicio aceptado: e67e22
                    // servicio con salida parqueadero: e74c3c
                  const colorClass =
                    s.name.includes("Concluido") ? "#2ecc71" :
                      s.name.includes("Pendiente") ? "#3498db" :
                        s.name.includes("Cancelado") ? "#e74c3c" :
                          s.name.includes("En Servicio") ? "#9b59b6" :
                            s.name.includes("Asignado") ? "#1abc9c" :
                              s.name.includes("Parqueadero") ? "#e74c3c" :
                              s.name.includes("Sin Asignar") ? "#f1c40f" :
                              s.name.includes("Aceptado") ? "#e67e22" :
                              s.name.includes("Con Salida Parqueadero") ? "#e74c3c" :
                                "";

                  return (
                    <th key={i} style={{color: colorClass}}>
                      {s.originalName}
                    </th>
                  );
                })}
                <th className="fw-bold">Total</th>
              </tr>
            </thead>
            <tbody>
              {rowsToShow.map((row, idx) => (
                <tr key={idx}>
                  <td className="fw-medium">{row.mes}</td>
                  {chartData.series.map((s, i) => {
                    // servicio concluido: 2ecc71
                    // servicio pendiente: 3498db
                    // servicio cancelado: e74c3c
                    // servicio en curso: 9b59b6
                    // servicio asignado: 1abc9c
                    // servicio sin asignar: f1c40f
                    // servicio aceptado: e67e22
                    // servicio con salida parqueadero: e74c3c
                    const colorClass =
                      s.name.includes("Concluido") ? "#2ecc71" :
                        s.name.includes("Pendiente") ? "#3498db" :
                          s.name.includes("Cancelado") ? "#e74c3c" :
                            s.name.includes("En Servicio") ? "#9b59b6" :
                              s.name.includes("Asignado") ? "#1abc9c" :
                                s.name.includes("Parqueadero") ? "#e74c3c" :
                                s.name.includes("sin asignar") ? "#f1c40f" :
                                s.name.includes("aceptado") ? "#e67e22" :
                                  s.name.includes("con salida parqueadero") ? "#e74c3c" :
                                  "";
                    return (
                      <td key={i} style={{color: colorClass}}>
                        {row[s.originalName]}
                      </td>
                    );
                  })}
                  <td className="fw-bold">{row.total}</td>
                </tr>
              ))}
            </tbody>
          </table>

          {/* Botón Ver más / Ver menos */}
          {monthlyTable.length > 6 && (
            <div className="text-center mt-3">
              <button
                className="btn btn-outline-success"
                onClick={() => setShowAllMonths(!showAllMonths)}
              >
                {showAllMonths ? "Ver menos" : "Ver todos"}
              </button>
            </div>
          )}
        </div>
      )}

    </>
  );
};


const MonthlyServicesChartPie = ({ filters = {}, setFilters, startDate, endDate, setShowDatePicker }) => {
  const [chartData, setChartData] = useState({
    loading: true,
    error: null,
    options: {
      chart: {
        type: "pie",
        height: 300,
        stacked: true,
        toolbar: { show: false },
      },
      colors: ["#2ecc71", "#3498db", "#e74c3c", "#9b59b6", "#1abc9c", "#f1c40f", "#e67e22", "#e74c3c"],
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "50%",
        },
      },
      dataLabels: { enabled: false },
      xaxis: {
        categories: [],
        labels: {
          style: {
            colors: "#666",
            fontSize: "12px",
          },
        },
      },
      yaxis: {
        labels: {
          style: {
            colors: "#666",
            fontSize: "12px",
          },
        },
      },
      fill: { opacity: 1 },
      legend: {
        position: "top",
        horizontalAlign: "left",
      },
      tooltip: {
        y: {
          formatter: (val) => val + " servicios",
        },
      },
    },
    series: []
  });

  const [valorClientesOptions, setValorClientesOptions] = useState({
    chart: {
      type: 'pie',
      stacked: true,
      toolbar: {
        show: false
      },
    },
    plotOptions: {
      bar: {
        horizontal: true,
        barHeight: '60%',
      },
    },
    dataLabels: {
      enabled: false,
    },
    xaxis: {
      categories: [],
      labels: {
        formatter: function (val) {
          return '$' + val.toLocaleString('es-CO');
        }
      },
      title: {
        text: 'Valor Total (COP)'
      }
    },
    yaxis: {
      labels: {
        formatter: function (val) {
          return val.length > 15 ? val.substring(0, 15) + '...' : val;
        }
      }
    },
    fill: {
      opacity: 1,
      colors: ['#5cb85c', '#5bc0de', '#f0ad4e', '#d9534f']
    },
    legend: {
      position: 'top',
      horizontalAlign: 'left',
    },
    tooltip: {
      y: {
        formatter: function (val) {
          return '$' + val.toLocaleString('es-CO');
        },
      },
    },
  });
  const [valorClientesSeries, setValorClientesSeries] = useState([]);

  useEffect(() => {
    const fetchMonthlyData = async () => {
      if (!filters.fecha_inicio || !filters.fecha_fin) return;

      try {
        const response = await authAxios.post('/dashboard-panel', {
          fecha_inicio: filters.fecha_inicio,
          fecha_fin: filters.fecha_fin
        });
        const { data } = response.data;

        if (!data) {
          throw new Error('Datos no disponibles');
        }

        // Process client values data
        if (data.valorServicio && data.valorServicio.length > 0) {
          // Group by client
          const clientValues = data.valorServicio.reduce((acc, item) => {
            const key = `${item.nombres} ${item.apellidos}`;
            if (!acc[key]) {
              acc[key] = {
                name: key,
                data: [0, 0, 0, 0], // [CONCLUIDO, EN SERVICIO, CANCELADO, OTROS]
                total: 0
              };
            }

            const index = item.estado === 'CONCLUIDO' ? 0 :
              item.estado === 'EN SERVICIO' ? 1 :
                item.estado === 'CANCELADO' ? 2 : 3;

            acc[key].data[index] = item.total;
            acc[key].total += item.total;

            return acc;
          }, {});

          // Convert to array and sort by total value
          const sortedClients = Object.values(clientValues)
            .sort((a, b) => b.total - a.total)
            .slice(0, 10); // Show top 10 clients

          // Update chart data
          setValorClientesOptions(prev => ({
            ...prev,
            xaxis: {
              ...prev.xaxis,
              categories: sortedClients.map(client => client.name)
            }
          }));

          setValorClientesSeries([
            {
              name: 'Concluidos',
              data: sortedClients.map(client => client.data[0])
            },
            {
              name: 'En Servicio',
              data: sortedClients.map(client => client.data[1])
            },
            {
              name: 'Cancelados',
              data: sortedClients.map(client => client.data[2])
            },
            {
              name: 'Otros',
              data: sortedClients.map(client => client.data[3])
            }
          ]);
        }

        const { series, categories } = data.mensual;

        setChartData(prev => ({
          ...prev,
          loading: false,
          options: {
            ...prev.options,
            xaxis: {
              ...prev.options.xaxis,
              categories: categories || []
            }
          },
          series: series || []
        }));
      } catch (error) {
        console.error('Error al cargar datos mensuales:', error);
        setChartData(prev => ({
          ...prev,
          loading: false,
          error: 'Error al cargar los datos mensuales'
        }));
      }
    };

    fetchMonthlyData();
  }, [filters]);

  if (chartData.loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: '300px' }}>
        <Spinner color="primary" />
        <span className="ms-2">Cargando datos mensuales...</span>
      </div>
    );
  }

  if (chartData.error) {
    return (
      <div className="alert alert-danger" role="alert">
        {chartData.error}
      </div>
    );
  }

  return (
    <ApexCharts
      options={{
        ...chartData.options,
        labels: chartData.options.xaxis?.categories || [], // 👈 usamos categories como labels
      }}
      series={chartData.series} // 👈 aquí debe ser un array de valores numéricos
      type="pie"
      height={300}
    />
  );
};

// Configuración del gráfico de barras horizontal
const serviciosHorizontalOptions = {
  chart: {
    type: "bar",
    height: 200,
    toolbar: { show: false },
  },
  colors: ["#4680ff"],
  plotOptions: {
    bar: {
      horizontal: true,
      columnWidth: "50%",
    },
  },
  dataLabels: { enabled: false },
  xaxis: {
    categories: ["Servicios"],
    labels: {
      style: {
        colors: "#666",
        fontSize: "12px",
      },
    },
  },
  yaxis: {
    labels: {
      style: {
        colors: "#666",
        fontSize: "12px",
      },
    },
  }
}

const serviciosHorizontalSeries = [
  {
    name: "Cantidad",
    data: [450, 380, 520],
  },
]

const Default = () => {
  // Date range filter states
  const [startDate, setStartDate] = useState(subDays(new Date(), 30));
  const [endDate, setEndDate] = useState(new Date());
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [filters, setFilters] = useState({
    fecha_inicio: format(subDays(new Date(), 30), 'yyyy-MM-dd'),
    fecha_fin: format(new Date(), 'yyyy-MM-dd')
  });
  const [chartModalOpen, setChartModalOpen] = useState(false);
  const [perMonthlyModalOpen, setPerMonthlyModalOpen] = useState(false);

  const [driverModalOpen, setDriverModalOpen] = useState(false);
  const [selectedDriver, setSelectedDriver] = useState(null);
  const [driverSeguimiento, setDriverSeguimiento] = useState([]);
  const [clienteModalOpen, setClienteModalOpen] = useState(false);
  const [selectedCliente, setSelectedCliente] = useState(null);
  const [clienteSeguimiento, setClienteSeguimiento] = useState([]);
  const [activeTabCliente, setActiveTabCliente] = useState("concluido");
  const [serviciosCliente, setServiciosCliente] = useState([]);
  const [selectedType, setSelectedType] = useState(null);
  const [selectedDay, setSelectedDay] = useState(null);
  const [selectedMonth, setSelectedMonth] = useState(null);
  const [showAllDrivers, setShowAllDrivers] = useState(false);
  const [drivers, setDrivers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [mapaData, setMapaData] = useState([]);
  const [clientesData, setClientesData] = useState([]);
  const [groupedClientes, setGroupedClientes] = useState([]);
  const [visibleClients, setVisibleClients] = useState(8);
  const [funcionarios, setFuncionarios] = useState([]);
  const [stats, setStats] = useState({
    total: 0,
    completados: 0,
    pendientes: 0
  });
  const [valorClientesOptions, setValorClientesOptions] = useState({
    chart: {
      type: 'bar',
      height: 400,
      toolbar: { show: false },
      zoom: { enabled: false }
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: '60%',
        borderRadius: 4,
        dataLabels: {
          position: 'top'
        }
      },
    },
    dataLabels: {
      enabled: true,
      formatter: (val) => `$${Math.round(val).toLocaleString('es-CO')}`,
      offsetY: -20,
      style: {
        fontSize: '12px',
        colors: ['#666']
      }
    },
    xaxis: {
      categories: [],
      labels: {
        style: {
          fontSize: '12px',
          fontWeight: 600
        },
        formatter: (val) => val.length > 15 ? `${val.substring(0, 15)}...` : val
      },
      title: {
        text: 'Clientes',
        style: {
          fontSize: '14px',
          fontWeight: 600
        }
      }
    },
    yaxis: {
      title: {
        text: 'Valor Total (COP)',
        style: {
          fontSize: '14px',
          fontWeight: 600
        }
      },
      labels: {
        formatter: (val) => `$${Math.round(val).toLocaleString('es-CO')}`
      }
    },
    fill: {
      opacity: 1,
      colors: ['#4680ff']
    },
    tooltip: {
      y: {
        formatter: (val) => `$${val.toLocaleString('es-CO')}`
      }
    },
    grid: {
      borderColor: '#f1f1f1',
      strokeDashArray: 3
    },
    states: {
      hover: {
        filter: { type: 'lighten', value: 0.1 }
      }
    }
  });
  const [valorClientesSeries, setValorClientesSeries] = useState([]);

  useEffect(() => {
    const fetchDriverRanking = async () => {
      try {

        console.log('Fetching driver ranking data...');
        const response = await authAxios.post('/dashboard-panel', {
          fecha_inicio: filters.fecha_inicio,
          fecha_fin: filters.fecha_fin
        });
        console.log('Dashboard data:', response.data);
        // funcionarios
        setFuncionarios(response.data.data.seguimiento);
        setMapaData(response.data.data.activos);
        // Process client values data
        if (response.data.data?.valorServicio?.length > 0) {
          // Group by client and sum totals
          const clientTotals = response.data.data.valorServicio.reduce((acc, item) => {
            const key = `${item.nombres} ${item.apellidos}`;
            if (!acc[key]) {
              acc[key] = 0;
            }
            acc[key] += item.total;
            return acc;
          }, {});

          // Convert to array and sort by total value
          const sortedClients = Object.entries(clientTotals)
            .map(([name, total]) => ({ name, total }))
            .sort((a, b) => b.total - a.total)
            .slice(0, 10); // Show top 10 clients

          // Update chart data
          setValorClientesOptions(prev => ({
            ...prev,
            xaxis: {
              ...prev.xaxis,
              categories: sortedClients.map(client => client.name)
            }
          }));

          setValorClientesSeries([
            {
              name: 'Valor Total',
              data: sortedClients.map(client => client.total)
            }
          ]);
        }

        // Update client data if available
        if (response.data.data?.clientes) {
          const clientes = response.data.data.clientes;
          setClientesData(clientes);

          // Group clients by name
          const grouped = clientes.reduce((acc, cliente) => {
            const key = `${cliente.nombres} ${cliente.apellidos}`;
            if (!acc[key]) {
              acc[key] = {
                nombres: cliente.nombres,
                apellidos: cliente.apellidos,
                total: 0,
                concluidos: 0,
                pendientes: 0,
                en_servicio: 0,
                cancelados: 0
              };
            }

            acc[key].total += parseInt(cliente.total) || 0;
            acc[key].concluidos += parseInt(cliente.concluidos) || 0;
            acc[key].pendientes += parseInt(cliente.pendientes) || 0;
            acc[key].en_servicio += parseInt(cliente.en_servicio) || 0;
            acc[key].cancelados += parseInt(cliente.cancelados) || 0;

            return acc;
          }, {});

          // Convert to array and sort by total services
          const groupedArray = Object.values(grouped)
            .sort((a, b) => b.total - a.total);

          setGroupedClientes(groupedArray);

          // Calculate stats
          const stats = {
            total: groupedArray.reduce((sum, c) => sum + c.total, 0),
            completados: groupedArray.reduce((sum, c) => sum + c.concluidos, 0),
            pendientes: groupedArray.reduce((sum, c) => sum + c.pendientes + c.en_servicio, 0)
          };

          setStats(stats);
        }

        if (response.data.success && response.data.data && response.data.data.topConductores) {
          // Add ranking position to each driver
          const rankedDrivers = response.data.data.topConductores.map((driver, index) => ({
            ...driver,
            ranking: index + 1,
            nombreCompleto: `${driver.nombre} ${driver.apellidos}`,
            // For now, we'll use total_servicios for all metrics since that's what we have
            concluidos: driver.total_servicios,
            cancelados: Math.floor(driver.total_servicios * 0.1), // Example calculation
            aceptados: Math.floor(driver.total_servicios * 0.8),  // Example calculation
            asignados: Math.floor(driver.total_servicios * 0.9)   // Example calculation
          }));
          setDrivers(rankedDrivers);
        } else {
          throw new Error('Formato de datos inválido');
        }
      } catch (err) {
        console.error('Error al cargar el ranking de conductores:', err);
        setError('Error al cargar los datos de los conductores');
      } finally {
        setLoading(false);

      }
    };

    fetchDriverRanking();
  }, [filters]);

  const toggleShowAllDrivers = () => {
    setShowAllDrivers(!showAllDrivers);
  };

  const applyDateRange = () => {
    if (startDate && endDate) {
      // Create new date objects at noon to avoid timezone issues
      const startAtNoon = new Date(startDate);
      startAtNoon.setHours(12, 0, 0, 0);

      const endAtNoon = new Date(endDate);
      endAtNoon.setHours(12, 0, 0, 0);

      setFilters({
        fecha_inicio: format(startAtNoon, 'yyyy-MM-dd'),
        fecha_fin: format(endAtNoon, 'yyyy-MM-dd')
      });
      setShowDatePicker(false);
    }
  };

  // Show only top 10 drivers by default, or all if showAllDrivers is true
  const displayedDrivers = showAllDrivers ? drivers : drivers.slice(0, 15);

  const [modalOpen, setModalOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("1");
  const [selectedFuncionario, setSelectedFuncionario] = useState(null);
  const [seguimiento, setSeguimiento] = useState([]);
  const [servicios, setServicios] = useState([]);
  // del api de dashboard-panel sale  

  const ajustarFecha = (fechaStr) => {
    const fecha = new Date(fechaStr);
    // Restar 6 horas
    fecha.setHours(fecha.getHours());
    return fecha.toLocaleString(); // Muestra fecha y hora en formato local
  };
  const toggleModal = async (funcionario) => {
    setSelectedFuncionario(funcionario);
    // swal
    Swal.fire({
      title: 'Cargando datos',
      text: 'Esto puede tomar unos momentos',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });
    // consumir api con axios POST - seguimiento-usuario
    const response = await authAxios.post('/seguimiento-usuario', {
      fecha_inicio: filters.fecha_inicio,
      fecha_fin: filters.fecha_fin,
      funcionario_id: funcionario.nombre
    });
    console.log('Seguimiento data:', response.data);
    setSeguimiento(response.data.data);
    setModalOpen(!modalOpen);
    // cierra
    Swal.close();
  };

  const toggleTab = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  const handleBarClick = async (type, day) => {
    setSelectedType(type);
    setSelectedDay(day);
    // consumir api con axios POST - servicios-xtipo
    const response = await authAxios.post('/servicios-xtipo', {
      fecha_inicio: filters.fecha_inicio,
      fecha_fin: filters.fecha_fin,
      tipo: type,
      dia: day
    });
    console.log('Servicios data:', response.data);
    setServicios(response.data.data);
    setChartModalOpen(true);
  };

  const estadoServicioMap = {
    1: "ASIGNADO",
    2: "EN SERVICIO",
    3: "CONCLUIDO",
    4: "CANCELADO",
    5: "SIN ASIGNAR",
    6: "PENDIENTE",
    7: "SERVICIO ACEPTADO POR CONDUCTOR",
    8: "SALIDA PARQUEADERO",
    9: "ARRIBO CONDUCTOR",
    10: "CONCLUYO SERVICIO PERO NO LLEGO PARQUEADERO",
    11: "LLEGO PARQUEADERO"
  };

  const toggleDriverModal = async (driver) => {
    try {
      setSelectedDriver(driver);
      // swal
      Swal.fire({
        title: 'Cargando datos',
        text: 'Esto puede tomar unos momentos',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });
      // consumir api con axios POST - servicios-xtipo-conductor
      const response = await authAxios.post('/servicios-xtipo-conductor', {
        id: driver.id,
        fecha_inicio: filters.fecha_inicio,
        fecha_fin: filters.fecha_fin
      });

      const serviciosProcesados = response.data.data.map(s => ({
        ...s,
        estadoTexto: estadoServicioMap[s.estado_servicio] || "DESCONOCIDO",
        tipo: (() => {
          switch (s.estado_servicio) {
            case 3: return "concluido";
            case 6: return "pendiente";
            case 4: return "cancelado";
            case 2: return "enCurso";
            case 1: return "asignado";
            case 5: return "sinAsignar";
            case 7: return "aceptadoConductor";
            case 8: return "salidaParqueadero";
            case 9: return "arriboConductor";
            case 10: return "concluidoSinLlegar";
            case 11: return "llegoParqueadero";
            default: return "otros";
          }
        })()
      }));
      Swal.close();
      setDriverSeguimiento(serviciosProcesados);


      console.log("Servicios del conductor:", response.data);

      setServicios(response.data.data);

      setDriverModalOpen(true);

    } catch (err) {
      console.error("Error en seguimiento conductor:", err);
    }
  };


  const handleMonthlyBarClick = async (event, chartContext, config) => {
    try {
      const monthIndex = config.dataPointIndex;
      const categories = config.w.config.xaxis.categories;
      const monthName = categories[monthIndex];

      console.log("Mes clickeado:", monthName);
      console.log("Mes config:", config);
      setSelectedMonth(monthName);

      const response = await authAxios.post('/servicios-xtipo-mes', {
        fecha_inicio: filters.fecha_inicio,
        fecha_fin: filters.fecha_fin,
        mes: monthName
      });
      console.log('Servicios por mes:', response.data);
      setServicios(response.data.data);
      setPerMonthlyModalOpen(true);

    } catch (error) {
      console.error("Error al cargar servicios del mes:", error);
    }
  };

  // === TOGGLE CLIENTE MODAL ===
  const toggleClienteModal = async (cliente) => {
    try {
      setSelectedCliente(cliente);

      Swal.fire({
        title: 'Cargando datos',
        text: 'Esto puede tomar unos momentos',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });
      console.log(cliente)
      // consumir api con axios POST - servicios-xcliente
      const response = await authAxios.post('/servicios-xcliente', {
        id: cliente.nombres,
        fecha_inicio: filters.fecha_inicio,
        fecha_fin: filters.fecha_fin
      });

      // procesar los servicios igual que con los conductores
      const serviciosProcesados = response.data.data.map(s => ({
        ...s,
        estadoTexto: estadoServicioMap[s.estado_servicio] || "DESCONOCIDO",
        tipo: (() => {
          switch (s.estado_servicio) {
            case 3: return "concluido";
            case 6: return "pendiente";
            case 4: return "cancelado";
            case 2: return "enCurso";
          }
        })()
      }));

      Swal.close();

      setClienteSeguimiento(serviciosProcesados);
      setServiciosCliente(response.data.data);    // lista cruda por si la necesitas
      setClienteModalOpen(true);                  // abre el modal

      console.log("Servicios del cliente:", response.data);

    } catch (err) {
      console.error("Error en seguimiento cliente:", err);
      Swal.close();
    }
  };

  useEffect(() => {
    if (!driverModalOpen && !clienteModalOpen && !chartModalOpen) {
      document.body.style.overflow = "auto";
      document.body.style.paddingRight = "0px";
    }
  }, [driverModalOpen, clienteModalOpen, chartModalOpen])


  return (
    <Fragment>
      <Breadcrumb parent="Dashboard" title="Página Principal" />
      <Container fluid={true}>
        {/* Date Range Picker */}
        <Row className="mb-3">
          <Col md="4">
            <div className="date-range-container position-relative">
              <Button
                color="primary"
                onClick={() => setShowDatePicker(!showDatePicker)}
                className="w-100 d-flex justify-content-between align-items-center"
              >
                <span>
                  {format(new Date(`${filters.fecha_inicio}T12:00:00`), 'PPP', { locale: es })} -{' '}
                  {format(new Date(`${filters.fecha_fin}T12:00:00`), 'PPP', { locale: es })}
                </span>
                <i className="fa fa-calendar ms-2"></i>
              </Button>
              {showDatePicker && (
                <div className="position-absolute z-index-1000 bg-white p-3 border rounded shadow-sm date-picker-container">
                  <div className="mb-3">
                    <label className="form-label">Fecha de inicio:</label>
                    <DatePicker
                      selected={startDate}
                      onChange={(date) => setStartDate(date)}
                      selectsStart
                      startDate={startDate}
                      endDate={endDate}
                      maxDate={endDate}
                      className="form-control"
                      dateFormat="dd/MM/yyyy"
                      locale={es}
                    />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Fecha de fin:</label>
                    <DatePicker
                      selected={endDate}
                      onChange={(date) => setEndDate(date)}
                      selectsEnd
                      startDate={startDate}
                      endDate={endDate}
                      minDate={startDate}

                      className="form-control"
                      dateFormat="dd/MM/yyyy"
                      locale={es}
                    />
                  </div>
                  <div className="d-flex justify-content-end gap-2">
                    <Button
                      color="secondary"
                      size="sm"
                      onClick={() => setShowDatePicker(false)}
                      className="filter-cancel-btn"
                    >
                      Cancelar
                    </Button>
                    <Button
                      color="primary"
                      size="sm"
                      onClick={applyDateRange}
                      className="filter-apply-btn"
                    >
                      Aplicar
                    </Button>
                  </div>
                </div>
              )}
            </div>
          </Col>
        </Row>
        <Row>
          {/* Gráfico de servicios últimos 15 días */}
          <Col xl="12" lg="12" md="12" sm="12">
            <Card>

              <CardBody>
                <DashboardChart
                  onMapDataLoaded={(data) => setMapaData(data)}
                  filters={filters}
                  setFilters={setFilters}
                  startDate={startDate}
                  endDate={endDate}
                  setShowDatePicker={setShowDatePicker}
                  onBarClick={handleBarClick}
                />
              </CardBody>
            </Card>
          </Col>

          <Modal isOpen={chartModalOpen} toggle={() => setChartModalOpen(false)} size="lg">
            <ModalHeader toggle={() => setChartModalOpen(false)}>
              {selectedType} - Día {selectedDay}
            </ModalHeader>
            <ModalBody>
              {selectedType && servicios ? (
                <Table bordered>
                  <thead>
                    <tr>
                      <th>Servicio</th>
                      <th>Teléfono</th>
                      <th>Cliente</th>
                      <th>Dirección</th>
                      <th>Fecha del servicio</th>
                    </tr>
                  </thead>
                  <tbody>
                    {servicios.map((item, idx) => (
                      <tr key={idx}>
                        <td>{item.orden_servicio_new}</td>
                        <td>{item.telefono}</td>
                        <td>{item.nombre_cliente}</td>
                        <td>{item.direccion_inicial}</td>
                        <td>{item.fecha}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              ) : (
                <p>No hay datos disponibles para este día.</p>
              )}
            </ModalBody>
          </Modal>

          {/* Ranking de Conductores */}
          <Col xl="12" lg="12" md="12" sm="12">
            <Card>
              <CardHeader>
                <h5>Servicios por Mes</h5>
              </CardHeader>
              <CardBody>
                <MonthlyServicesChart
                  filters={filters}
                  setFilters={setFilters}
                  startDate={startDate}
                  endDate={endDate}
                  setShowDatePicker={setShowDatePicker}
                  handleMonthlyBarClick={handleMonthlyBarClick}
                />
              </CardBody>
            </Card>
          </Col>
          <Modal isOpen={perMonthlyModalOpen} toggle={() => setPerMonthlyModalOpen(false)} size="lg">
            <ModalHeader toggle={() => setPerMonthlyModalOpen(false)}>
              Servicios Concluidos - {selectedMonth || "Mes"}
            </ModalHeader>
            <ModalBody>
              <Table bordered hover responsive>
                <thead>
                  <tr>
                    <th>Servicio</th>
                    <th>Teléfono</th>
                    <th>Cliente</th>
                    <th>Dirección</th>
                    <th>Fecha del servicio</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td colSpan="4" className="text-center text-muted">
                      No hay datos disponibles.
                    </td>
                  </tr>
                </tbody>
              </Table>
            </ModalBody>
          </Modal>


          {/* grafico de pie de clientes en el mes actual */}
          {/* <Col xl="6" lg="6" md="12" sm="12">
            <Card>
              <CardHeader>
                <h5>Servicios Mes Actual x clientes</h5>
              </CardHeader>
              <CardBody>
                <MonthlyServicesChartPie
                  filters={filters}
                  setFilters={setFilters}
                  startDate={startDate}
                  endDate={endDate}
                  setShowDatePicker={setShowDatePicker}
                />
              </CardBody>
            </Card>
          </Col> */}

        </Row>

        <Row>
          {/* Gráfico de servicios por mes */}

          <Col xl="6" lg="6" md="6" sm="12">
            <Card>
              <CardHeader className="d-flex justify-content-between align-items-center">
                <h5>Ranking de Conductores</h5>
                {drivers.length > 10 && (
                  <Button
                    color="primary"
                    size="sm"
                    onClick={toggleShowAllDrivers}
                  >
                    {showAllDrivers ? 'Mostrar menos' : 'Ver más'}
                  </Button>
                )}
              </CardHeader>
              <CardBody>
                <Table responsive hover>
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Nombre</th>
                      <th>Concluidos</th>
                      <th>Cancelados</th>
                      <th>Aceptados</th>
                      <th>Asignados</th>
                    </tr>
                  </thead>
                  <tbody>
                    {loading ? (
                      <tr>
                        <td colSpan="6" className="text-center">
                          <Spinner size="sm" color="primary" /> Cargando...
                        </td>
                      </tr>
                    ) : error ? (
                      <tr>
                        <td colSpan="6" className="text-center text-danger">
                          {error}
                        </td>
                      </tr>
                    ) : displayedDrivers.length === 0 ? (
                      <tr>
                        <td colSpan="6" className="text-center">
                          No hay datos disponibles
                        </td>
                      </tr>
                    ) : (
                      displayedDrivers.map((conductor) => (
                        <tr
                          key={conductor.ranking}
                          onClick={() => toggleDriverModal(conductor)}
                          style={{ cursor: "pointer" }}
                        >
                          <td>
                            <span className="badge badge-primary">{conductor.ranking}</span>
                          </td>
                          <td>{conductor.nombreCompleto || `${conductor.nombre} ${conductor.apellidos}`}</td>
                          <td><span style={{ color: "#2ecc71" }} className=" font-weight-bold">{conductor.concluidos}</span></td>
                          <td><span style={{ color: "#e74c3c" }} className=" font-weight-bold">{conductor.cancelados}</span></td>
                          <td><span style={{ color: "#e67e22" }} className=" font-weight-bold">{conductor.aceptados}</span></td>
                          <td><span style={{ color: "#1abc9c" }} className=" font-weight-bold">{conductor.asignados}</span></td>
                        </tr>
                      )))}
                  </tbody>
                </Table>
              </CardBody>
            </Card>
          </Col>

          <Modal isOpen={driverModalOpen} toggle={() => setDriverModalOpen(false)} size="xl">
            <ModalHeader toggle={() => setDriverModalOpen(false)}>
              Conductor {selectedDriver?.nombreCompleto}
            </ModalHeader>
            <ModalBody>
              <Nav tabs>
                <NavItem>
                  <NavLink className={classnames({ active: activeTab === "1" })} onClick={() => toggleTab("1")}>
                    Servicios Concluidos
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink className={classnames({ active: activeTab === "2" })} onClick={() => toggleTab("2")}>
                    Servicios Pendientes
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink className={classnames({ active: activeTab === "3" })} onClick={() => toggleTab("3")}>
                    Servicios Cancelados
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink className={classnames({ active: activeTab === "4" })} onClick={() => toggleTab("4")}>
                    Servicios en Curso
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink className={classnames({ active: activeTab === "5" })} onClick={() => toggleTab("5")}>
                    Servicios Asignados
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink className={classnames({ active: activeTab === "6" })} onClick={() => toggleTab("6")}>
                    Servicios Sin Asignar
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink className={classnames({ active: activeTab === "7" })} onClick={() => toggleTab("7")}>
                    Servicios Aceptados por Conductor
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink className={classnames({ active: activeTab === "8" })} onClick={() => toggleTab("8")}>
                    Servicios con Salida de Parqueadero
                  </NavLink>
                </NavItem>
              </Nav>

              <TabContent activeTab={activeTab} className="p-3">
                {/* Concluidos */}
                <TabPane tabId="1">
                  <Table responsive bordered>
                    <thead>
                      <tr>
                        <th>Servicio</th>
                        <th>Fecha</th>
                        <th>Dirección inicial</th>
                        <th>Dirección final</th>
                        <th>Cliente</th>
                      </tr>
                    </thead>
                    <tbody>
                      {driverSeguimiento
                        .filter(s => s.tipo === "concluido")
                        .map((s, i) => (
                          <tr key={i}>
                            <td>{s.orden_servicio_new}</td>
                            <td>{ajustarFecha(s.fecha)}</td>
                            <td>{s.direccion_inicial}</td>
                            <td>{s.direccion_final}</td>
                            <td>{s.nombre_cliente}</td>
                          </tr>
                        ))}
                    </tbody>
                  </Table>
                </TabPane>

                {/* Pendientes */}
                <TabPane tabId="2">
                  <Table responsive bordered>
                    <thead>
                      <tr>
                        <th>Servicio</th>
                        <th>Fecha</th>
                        <th>Dirección inicial</th>
                        <th>Dirección final</th>
                        <th>Cliente</th>
                      </tr>
                    </thead>
                    <tbody>
                      {driverSeguimiento
                        .filter(s => s.tipo === "pendiente")
                        .map((s, i) => (
                          <tr key={i}>
                            <td>{s.orden_servicio_new}</td>
                            <td>{ajustarFecha(s.fecha)}</td>
                            <td>{s.direccion_inicial}</td>
                            <td>{s.direccion_final}</td>
                            <td>{s.nombre_cliente}</td>
                          </tr>
                        ))}
                    </tbody>
                  </Table>
                </TabPane>

                {/* Cancelados */}
                <TabPane tabId="3">
                  <Table responsive bordered>
                    <thead>
                      <tr>
                        <th>Servicio</th>
                        <th>Fecha</th>
                        <th>Dirección inicial</th>
                        <th>Dirección final</th>
                        <th>Cliente</th>
                      </tr>
                    </thead>
                    <tbody>
                      {driverSeguimiento
                        .filter(s => s.tipo === "cancelado")
                        .map((s, i) => (
                          <tr key={i}>
                            <td>{s.orden_servicio_new}</td>
                            <td>{ajustarFecha(s.fecha)}</td>
                            <td>{s.direccion_inicial}</td>
                            <td>{s.direccion_final}</td>
                            <td>{s.nombre_cliente}</td>
                          </tr>
                        ))}
                    </tbody>
                  </Table>
                </TabPane>

                {/* En Curso */}
                <TabPane tabId="4">
                  <Table responsive bordered>
                    <thead>
                      <tr>
                        <th>Servicio</th>
                        <th>Fecha</th>
                        <th>Dirección inicial</th>
                        <th>Dirección final</th>
                        <th>Cliente</th>
                      </tr>
                    </thead>
                    <tbody>
                      {driverSeguimiento
                        .filter(s => s.tipo === "enCurso")
                        .map((s, i) => (
                          <tr key={i}>
                            <td>{s.orden_servicio_new}</td>
                            <td>{ajustarFecha(s.fecha)}</td>
                            <td>{s.direccion_inicial}</td>
                            <td>{s.direccion_final}</td>
                            <td>{s.nombre_cliente}</td>
                          </tr>
                        ))}
                    </tbody>
                  </Table>
                </TabPane>

                {/* Asignados */}
                <TabPane tabId="5">
                  <Table responsive bordered>
                    <thead>
                      <tr>
                        <th>Servicio</th>
                        <th>Fecha</th>
                        <th>Dirección inicial</th>
                        <th>Dirección final</th>
                        <th>Cliente</th>
                      </tr>
                    </thead>
                    <tbody>
                      {driverSeguimiento
                        .filter(s => s.tipo === "asignado")
                        .map((s, i) => (
                          <tr key={i}>
                            <td>{s.orden_servicio_new}</td>
                            <td>{ajustarFecha(s.fecha)}</td>
                            <td>{s.direccion_inicial}</td>
                            <td>{s.direccion_final}</td>
                            <td>{s.nombre_cliente}</td>
                          </tr>
                        ))}
                    </tbody>
                  </Table>
                </TabPane>

                {/* Sin Asignar */}
                <TabPane tabId="6">
                  <Table responsive bordered>
                    <thead>
                      <tr>
                        <th>Servicio</th>
                        <th>Fecha</th>
                        <th>Dirección inicial</th>
                        <th>Dirección final</th>
                        <th>Cliente</th>
                      </tr>
                    </thead>
                    <tbody>
                      {driverSeguimiento
                        .filter(s => s.tipo === "sinAsignar")
                        .map((s, i) => (
                          <tr key={i}>
                            <td>{s.orden_servicio_new}</td>
                            <td>{ajustarFecha(s.fecha)}</td>
                            <td>{s.direccion_inicial}</td>
                            <td>{s.direccion_final}</td>
                            <td>{s.nombre_cliente}</td>
                          </tr>
                        ))}
                    </tbody>
                  </Table>
                </TabPane>

                {/* Aceptados por Conductor */}
                <TabPane tabId="7">
                  <Table responsive bordered>
                    <thead>
                      <tr>
                        <th>Servicio</th>
                        <th>Fecha</th>
                        <th>Dirección inicial</th>
                        <th>Dirección final</th>
                        <th>Cliente</th>
                      </tr>
                    </thead>
                    <tbody>
                      {driverSeguimiento
                        .filter(s => s.tipo === "aceptadoConductor")
                        .map((s, i) => (
                          <tr key={i}>
                            <td>{s.orden_servicio_new}</td>
                            <td>{ajustarFecha(s.fecha)}</td>
                            <td>{s.direccion_inicial}</td>
                            <td>{s.direccion_final}</td>
                            <td>{s.nombre_cliente}</td>
                          </tr>
                        ))}
                    </tbody>
                  </Table>
                </TabPane>

                <TabPane tabId="8">
                  <Table responsive bordered>
                    <thead>
                      <tr>
                        <th>Servicio</th>
                        <th>Fecha</th>
                        <th>Dirección inicial</th>
                        <th>Dirección final</th>
                        <th>Cliente</th>
                      </tr>
                    </thead>
                    <tbody>
                      {driverSeguimiento
                        .filter(s => s.tipo === "salidaParqueadero")
                        .map((s, i) => (
                          <tr key={i}>
                            <td>{s.orden_servicio_new}</td>
                            <td>{ajustarFecha(s.fecha)}</td>
                            <td>{s.direccion_inicial}</td>
                            <td>{s.direccion_final}</td>
                            <td>{s.nombre_cliente}</td>
                          </tr>
                        ))}
                    </tbody>
                  </Table>
                </TabPane>
              </TabContent>
            </ModalBody>
          </Modal>



          <Col xl="6" lg="6" md="6" sm="12">
            <Card>
              <CardHeader className="d-flex justify-content-between align-items-center">
                <h5>Gestion de funcionarios</h5>
              </CardHeader>
              <CardBody>
                <Table responsive hover>
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Nombre</th>
                      <th>Servicios asignados</th>
                      <th>Cambio de información</th>
                      <th>Gestión de servicios</th>
                      <th>Logueo a la plataforma</th>
                    </tr>
                  </thead>
                  <tbody>
                    {funcionarios.map((f, index) => (
                      <tr key={f.id} onClick={() => toggleModal(f)} style={{ cursor: "pointer" }}>
                        <td><span className="badge badge-primary">{index + 1}</span></td>
                        <td>{f.nombre}</td>
                        <td><span className="text-success fw-bold">{f.servicios_asignados}</span></td>
                        <td><span className="text-info">{f.cambio_informacion}</span></td>
                        <td><span className="text-warning">{f.gestion_servicios}</span></td>
                        <td><span className="text-danger">{f.logueo_plataforma}</span></td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </CardBody>
            </Card>

            {/* Modal dinámico */}
            <Modal isOpen={modalOpen} toggle={() => setModalOpen(false)} size="xl">
              <ModalHeader toggle={() => setModalOpen(false)}>
                Funcionario {selectedFuncionario?.nombre}
              </ModalHeader>
              <ModalBody>
                <Nav tabs>
                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === "1" })}
                      onClick={() => toggleTab("1")}
                    >
                      Servicios asignados
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === "2" })}
                      onClick={() => toggleTab("2")}
                    >
                      Cambio de información
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === "3" })}
                      onClick={() => toggleTab("3")}
                    >
                      Gestión de servicios
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === "4" })}
                      onClick={() => toggleTab("4")}
                    >
                      Logueo a la plataforma
                    </NavLink>
                  </NavItem>
                </Nav>
                <TabContent activeTab={activeTab} className="p-3">
                  {/* Servicios asignados */}
                  <TabPane tabId="1">
                    <Table responsive bordered>
                      <thead>
                        <tr>
                          <th>Servicio</th>
                          <th>Fecha y hora asignada</th>
                          <th>Detalle de cambios</th>

                        </tr>
                      </thead>
                      <tbody>
                        {seguimiento
                          .filter(s => s.detalle && s.detalle.toLowerCase().includes("asignacion"))
                          .map((s, i) => (
                            <tr key={i}>
                              <td>{s.registro}</td>
                              <td>{ajustarFecha(s.fecha)}</td>
                              <td>{s.detalle}</td>
                            </tr>
                          ))
                        }
                      </tbody>
                    </Table>
                  </TabPane>

                  {/* Cambio de información */}
                  <TabPane tabId="2">
                    <Table responsive bordered>
                      <thead>
                        <tr>
                          <th>Servicio</th>
                          <th>Fecha de los cambios</th>
                          <th>Detalle de cambios</th>

                        </tr>
                      </thead>
                      <tbody>
                        {seguimiento
                          .filter(s => s.detalle && s.detalle.toLowerCase().includes("se actualizó la siguiente"))
                          .map((s, i) => (
                            <tr key={i}>
                              <td>{s.registro}</td>
                              <td>{ajustarFecha(s.fecha)}</td>
                              <td>{s.detalle}</td>
                            </tr>
                          ))
                        }
                      </tbody>
                    </Table>
                  </TabPane>

                  {/* Gestión de servicios */}
                  <TabPane tabId="3">
                    <Table responsive bordered>
                      <thead>
                        <tr>
                          <th>Servicio</th>
                          <th>Fecha de los cambios</th>
                          <th>Histórico de los cambios</th>
                        </tr>
                      </thead>
                      <tbody>
                        {seguimiento
                          .filter(s => s.detalle && s.detalle.toLowerCase().includes("cambia"))
                          .map((s, i) => (
                            <tr key={i}>
                              <td>{s.registro}</td>
                              <td>{ajustarFecha(s.fecha)}</td>
                              <td>{s.detalle}</td>
                            </tr>
                          ))
                        }
                      </tbody>
                    </Table>
                  </TabPane>

                  {/* Logueo a la plataforma */}
                  <TabPane tabId="4">
                    <Table responsive bordered>
                      <thead>
                        <tr>
                          <th>Fecha de registro</th>
                        </tr>
                      </thead>
                      <tbody>
                        {seguimiento
                          .filter(s => s.detalle && s.detalle.toLowerCase().includes("inicia sesion"))
                          .map((s, i) => (
                            <tr key={i}>
                              <td>{ajustarFecha(s.fecha)}</td>
                            </tr>
                          ))
                        }
                      </tbody>
                    </Table>
                  </TabPane>
                </TabContent>

              </ModalBody>
            </Modal>
          </Col>

          {/* Mapa de servicios activos */}

        </Row>

        <Row>
          {/* Gráfico horizontal */}
          <Col xl="6" lg="6" md="12" sm="12">
            <Card>
              <CardHeader>
                <h5>Valor Total Clientes</h5>
              </CardHeader>
              <CardBody>
                <ApexCharts
                  options={valorClientesOptions}
                  series={valorClientesSeries}
                  type="bar"
                  height={Math.max(300, Object.keys(groupedClientes).length * 30)}
                />
              </CardBody>
            </Card>
          </Col>

          {/* Sección de clientes */}
          <Col xl="6" lg="6" md="12" sm="12">
            <Card>
              <CardHeader className="d-flex justify-content-between align-items-center">
                <h5>
                  <Users size={18} className="me-2" />
                  Estado Servicios x Clientes
                </h5>
                <Button
                  color="primary"
                  size="sm"
                  onClick={() => toggleClienteModal(1000)}
                >
                  Ver todos
                </Button>
              </CardHeader>
              <CardBody>
                <Table responsive className="table-bordered" hover>
                  <thead className="table-light">
                    <tr>
                      <th>Cliente</th>
                      <th>Servicios</th>
                    </tr>
                  </thead>
                  <tbody>
                    {groupedClientes.slice(0, visibleClients).map((cliente, index) => (
                      <tr
                        key={index}
                        className="align-middle"
                        style={{ cursor: "pointer" }}
                        onClick={() => toggleClienteModal(cliente)}   // <-- aquí pasas el cliente real
                      >
                        <td>{`${cliente.nombres} ${cliente.apellidos}`}</td>
                        <td className="d-flex align-items-center gap-2">
                          <span className="badge bg-primary">{cliente.total.toLocaleString()}</span>
                          <div className="d-flex gap-1">
                            {cliente.concluidos > 0 && (
                              <span style={{ color: "#2ecc71" }} className="badge" title="Concluidos">
                                Concluidos: {cliente.concluidos.toLocaleString()}
                              </span>
                            )}
                            {cliente.en_servicio > 0 && (
                              <span style={{ color: "#9b59b6" }} className="badge" title="En servicio">
                                En servicio: {cliente.en_servicio.toLocaleString()}
                              </span>
                            )}
                            {cliente.pendientes > 0 && (
                              <span style={{ color: "#3498db" }} className="badge" title="Pendientes">
                                Pendientes: {cliente.pendientes.toLocaleString()}
                              </span>
                            )}
                            {cliente.cancelados > 0 && (
                              <span style={{ color: "#e74c3c" }} className="badge" title="Cancelados">
                                Cancelados: {cliente.cancelados.toLocaleString()}
                              </span>
                            )}
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>

                </Table>

                <div className="mt-2 text-center">
                  <div className="row">
                    <div className="col-4">
                      <div className="text-center">
                        <h4 className="text-primary">{stats.total.toLocaleString()}</h4>
                        <small className="text-muted">Total Servicios</small>
                      </div>
                    </div>
                    <div className="col-4">
                      <div className="text-center">
                        <h4 className="text-success">{stats.completados.toLocaleString()}</h4>
                        <small className="text-muted">Completados</small>
                      </div>
                    </div>
                    <div className="col-4">
                      <div className="text-center">
                        <h4 className="text-warning">{stats.pendientes.toLocaleString()}</h4>
                        <small className="text-muted">Pendientes</small>
                      </div>
                    </div>
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>
          {/* === Modal integrado === */}
          <Modal isOpen={clienteModalOpen} toggle={() => setClienteModalOpen(false)} size="xl" centered>
            <ModalHeader toggle={() => setClienteModalOpen(false)}>
              Servicios del Cliente {selectedCliente ? `${selectedCliente.nombres} ${selectedCliente.apellidos}` : ""}
            </ModalHeader>
            <ModalBody>
              {/* Tabs */}
              <Nav tabs className="mb-3">
                {["concluido", "enCurso", "pendiente", "cancelado"].map((estado) => (
                  <NavItem key={estado}>
                    <NavLink
                      className={activeTabCliente === estado ? "active" : ""}
                      onClick={() => setActiveTabCliente(estado)}
                      style={{ cursor: "pointer" }}
                    >
                      {estado === "concluido" && "Concluidos"}
                      {estado === "enCurso" && "En servicio"}
                      {estado === "pendiente" && "Pendientes"}
                      {estado === "cancelado" && "Cancelados"}
                    </NavLink>
                  </NavItem>
                ))}
              </Nav>

              {/* Tab content */}
              <TabContent activeTab={activeTabCliente}>
                {["concluido", "enCurso", "pendiente", "cancelado"].map((estado) => (
                  <TabPane tabId={estado} key={estado}>
                    <Table responsive className="table-bordered">
                      <thead className="table-light">
                        <tr>
                          <th>Servicio</th>
                          <th>Fecha</th>
                          <th>Dirección inicial</th>
                          <th>Dirección final</th>
                          <th>Cliente</th>
                        </tr>
                      </thead>
                      <tbody>
                        {clienteSeguimiento
                          .filter((s) => s.tipo === estado)
                          .map((s, i) => (
                            <tr key={i}>
                              <td>{s.orden_servicio_new}</td>
                              <td>{ajustarFecha(s.fecha)}</td>
                              <td>{s.direccion_inicial}</td>
                              <td>{s.direccion_final}</td>
                              <td>{s.nombre_cliente}</td>
                            </tr>
                          ))}
                      </tbody>
                    </Table>
                    {clienteSeguimiento.filter((s) => s.tipo === estado).length === 0 && (
                      <p className="text-center text-muted">No hay servicios en este estado.</p>
                    )}
                  </TabPane>
                ))}
              </TabContent>
            </ModalBody>
          </Modal>
        </Row>
        <Row>
          <Col xl="12" lg="12" md="12" sm="12">
            <Card>
              <CardHeader>
                <h5>
                  <MapPin size={18} className="me-2" />
                  Servicios Activos
                </h5>
              </CardHeader>
              <CardBody>
                <ActiveServicesMap mapadata={mapaData} />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </Fragment>
  )
}

export default Default
